import { HttpAction } from "@megaron/http-service";
import { Serializers } from "@megaron/serializers";

export const imapActions = {
  imapSync: HttpAction({
    path: "/imap/sync",
    method: "get",
    valueSerializer: Serializers.object({
      syncedAt: Serializers.datetime,
      messageCount: Serializers.integer,
    }),
    errorSerializer: Serializers.stringOneOf("NotConfigured", "SyncFailed"),
    requiresAuth: true,
  }),

  imapConnectionStatus: HttpAction({
    path: "/imap/connection",
    method: "get",
    valueSerializer: Serializers.object({
      connected: Serializers.boolean,
      mailboxes: Serializers.array(
        Serializers.object({
          email: Serializers.string,
          imapHost: Serializers.string,
          imapPort: Serializers.integer,
          imapTls: Serializers.boolean,
          smtpHost: Serializers.string,
          smtpPort: Serializers.integer,
          smtpTls: Serializers.boolean,
          username: Serializers.string,
        }),
      ),
    }),
    requiresAuth: true,
  }),

  imapConnect: HttpAction({
    path: "/imap/connect",
    method: "post",
    bodySerializer: Serializers.object({
      email: Serializers.string,
      imapHost: Serializers.string,
      imapPort: Serializers.integer,
      imapTls: Serializers.boolean,
      smtpHost: Serializers.string,
      smtpPort: Serializers.integer,
      smtpTls: Serializers.boolean,
      username: Serializers.string,
      password: Serializers.string,
    }),
    valueSerializer: Serializers.object({ email: Serializers.string }),
    errorSerializer: Serializers.stringOneOf(
      "EncryptionKeyNotConfigured",
      "CredentialDecryptionFailed",
      "ConnectionFailed",
      "SmtpConnectionFailed",
    ),
    requiresAuth: true,
  }),

  imapDisconnect: HttpAction({
    path: "/imap/disconnect",
    method: "post",
    bodySerializer: Serializers.object({
      email: Serializers.string.optional(),
    }),
    valueSerializer: Serializers.object({ ok: Serializers.boolean }),
    requiresAuth: true,
  }),
};
